//TODO Make it look like ECC's footer
//https://eccgear.com/
// src/components/Footer.js
import './Footer.css';

const Footer = () => {

return (
<footer className="footer">
    <div className="footer-content">
    <div className="footer-main">
        <div className="footer-company">
        <h3>NIGHT OBSERVATION DEVICE RENTALS //</h3>
        <p>[ Website Version 0.0.9]</p>
        <p>[ CAGE: 13FT3]</p>
        <p>[ UEI: XP3MEKKSUA29]</p>
        </div>
        
        <div className="footer-navigation">
        <div className="footer-section">
            <h4 className="footer-section-title">WEBSITE NAVIGATION</h4>
            <div className="footer-section-links">
            <a href="/">HOME</a>
            <a href="/night-vision">NIGHT VISION</a>
            <a href="/thermal">THERMAL DEVICES</a>
            <a href="/solutions">OTHER CAPABILITIES</a>
            <a href="/about">ABOUT US</a>
            <a href="/contact">CONTACT & FAQ</a>
            </div>
        </div>
        
        <div className="footer-section">
            <h4 className="footer-section-title">ELECTRONIC MAIL</h4>
            <div className="email-signup">
            <input type="email" placeholder="Your E-mail" />
            <button>SIGN UP</button>
            <p className="signup-text">
                We value your time and privacy. Sign up for brief updates on new equipment availability, special offers, and early access to our latest night vision technology.
            </p>
            </div>
        </div>
        </div>
    </div>
    
    <div className="footer-copyright">
        <p>© 2025 Hidden Capabilities LLC.</p>
        <div className="footer-legal">
        <a href="/privacy">Privacy Policy</a>
        <a href="/ITAR">ITAR</a>
        <a href="/rental-agreement">Rental Agreement</a>
        <a href="/refund">Refund Policy</a>
        </div>
    </div>
    </div>
</footer>
);
};

export default Footer;